export default __webpack_public_path__ + "assets/images/67a97948fcde6e56944c1ea1bfabe5b4.svg";